import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { Anchor, Body2, Center } from '@myphx-engineering/phx-design-system';

import { useMedicationConfigOverride } from '../../../../contexts/DrugProgramProvider';
import {
    useFillPathway,
    useFillPrescription,
} from '../../../../contexts/fill/use-fill-prescription';
import { usePathwayScreen } from '../../../../hooks/use-pathway-screen';
import { shouldShowHoldButton } from '../../../../util/config/show-hold-button';
import { getAbsoluteRoute } from '../../../../util/get-absolute-route';
import { getMedicationNdc } from '../../../../util/get-medication-ndc';

import { PlaceOnHoldButton } from './PlaceOnHoldButton';

export const PharmacyPreviewSubCta = () => {
    const { t } = useTranslation('lilly');
    const [searchParams] = useSearchParams();

    const { drxId, medication } = useFillPrescription();
    const { isPathwayOverridden, pathway, subPathway } = useFillPathway();
    const screen = usePathwayScreen();

    const ndc = getMedicationNdc(medication);
    const medConfig = useMedicationConfigOverride();

    const onHoldConfig = ndc ? (medConfig.ndcHoldConfigs?.[ndc] ?? null) : null;

    const query = searchParams.toString();

    if (shouldShowHoldButton(onHoldConfig, pathway, subPathway, screen)) {
        return (
            <PlaceOnHoldButton
                onHoldConfig={onHoldConfig!}
                prescriberOrderId={drxId}
            />
        );
    }

    if (pathway === 'self-pay' && !isPathwayOverridden) {
        return (
            <Center>
                <Anchor
                    href={`${getAbsoluteRoute('fill.drxId.pathSelect', {
                        drxId,
                    })}${query ? `?${query}` : ''}`}
                >
                    <Body2 color="primary">
                        {t('fill.selfPay.coverage.thinkInsurance')}
                    </Body2>
                </Anchor>
            </Center>
        );
    }

    return null;
};
